import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getUserTypeName } from '../auth/constants';

import { getCompanySlug } from '~/assets/utils/getCompanySlug';
import { TenantService } from '~/services/api/tenant/endpoints';
import { useAuthSlice } from '~/slices/auth';

export const getSlugFromURL = () => {
  const WB_URL =
    import.meta.env.VITE_NODE_ENV === 'dev'
      ? import.meta.env.VITE_DEV_FALLBACK_URL
      : window.location.hostname;

  return getCompanySlug(WB_URL);
};

export const useLocationSlug = () => {
  const [slug, setSlug] = useState(getSlugFromURL());
  const location = useLocation();
  useEffect(() => {
    setSlug(getSlugFromURL());
  }, [location.pathname]);
  return slug;
};

export const useTenantSlug = () => {
  const slice = useAuthSlice().auth;
  const userTypeName = getUserTypeName(slice.user.type);

  const storedSlug = slice.user.slug ?? '';
  const tenantSlug =
    TenantService.endpoints.userTenant.useQuery(undefined, {
      skip: !slice.user.isSessionExpired || userTypeName === 'WHISTLE_BLOWER',
    }).data?.slug ?? '';

  /**
   * Since the cookie can still exist after the user calling '/logout`,
   * we need to check if the user is logged in by checking the session state
   * If the session is expired, we should not return the slug.
   */
  const isSessionExpired = slice.user.isSessionExpired;
  if (isSessionExpired) {
    return '';
  }

  return storedSlug || tenantSlug;
};

export const useTenantID = () => {
  const slice = useAuthSlice().auth;

  const query = TenantService.endpoints.userTenant.useQuery();
  const tenantID = query.data?.id ?? 0;

  /**
   * Since the cookie can still exist after the user calling '/logout`,
   * we need to check if the user is logged in by checking the session state
   * If the session is expired, we should not return the slug.
   */
  const isSessionExpired = slice.user.isSessionExpired;
  if (isSessionExpired) {
    return 0;
  }

  return tenantID;
};
